// Converted to SCSS module
import Link from 'next/link'

import { Image } from '@/shared/ui/Image'
import { Margin } from '@/shared/ui/margin'

import styles from './AdvLine.module.scss'

export type AdvDetailedProps = {
	title?: string
	subtitle?: string
	link?: string
	buttonText?: string
	bigImage?: boolean
	image?: {
		width: number
		height: number
		src: string
		bigImage?: boolean
	}
	withRedirectLink?: boolean
	redirectLink?: string
	backgroundColor?: string
}

export const AdvLine = ({
	title,
	subtitle,
	image,
	redirectLink,
	withRedirectLink,
	backgroundColor
}: AdvDetailedProps): JSX.Element => {
	const style: React.CSSProperties = {}
	if (backgroundColor) {
		style['--advline-bg' as any] = backgroundColor
	}

	return (
		<section className={styles.advLine} style={style}>
			<div className={styles.content}>
				<div className={styles.text}>
					{title && (
						<Margin mb="2x">
							<h2 className={styles.title}>{title}</h2>
						</Margin>
					)}
					{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
					{withRedirectLink && (
						<Margin mt="3x">
							<Link
								prefetch={false}
								href={redirectLink}
								className={`${styles.link} js-gtm-service-iport-click`}
								target="_blank">
								Подробнее
							</Link>
						</Margin>
					)}
				</div>
				<div className={styles.imageWrap}>
					<Image alt={title || subtitle} src={image.src} width={image.width} height={image.height} />
				</div>
			</div>
		</section>
	)
}
